/* EclatDent — tiroir d'upsell : s'ouvre à chaque ajout au panier, jauge livraison + suggestions */
(() => {
  if (window.__edupInit) return;
  window.__edupInit = true;

  const root = document.querySelector('[data-edup]');
  if (!root) return;
  // le panier a déjà sa jauge et son upsell : pas de tiroir là-bas
  if (document.querySelector('[data-edcart]')) return;

  const freeQty = Number(root.dataset.freeQty) || 2;
  const shipPrice = root.dataset.shipPrice || '';
  // Chaînes traduites injectées par le snippet (locales/*.json, ed.up.js_*)
  const T = {
    free: root.dataset.tFree || '🚀 <b>Livraison offerte</b> — c’est cadeau.',
    missingOne: root.dataset.tMissingOne || 'Plus que <b>1 tube</b> pour la <b>livraison offerte</b> (sinon [price])',
    missingMany: root.dataset.tMissingMany || 'Plus que <b>[count] tubes</b> pour la <b>livraison offerte</b> (sinon [price])',
    packDiff: root.dataset.tPackDiff || 'Pour <b>[diff] de plus</b>, passe au <b>pack 3 tubes</b> — ton 3ᵉ tube est quasi offert.',
    suggestFree: root.dataset.tSuggestFree || 'Complète ta routine — toujours livré offert :',
    suggestAdd: root.dataset.tSuggestAdd || 'Ajoute un tube, la livraison est offerte :',
  };
  const panel = root.querySelector('.edup-panel');
  const shipLabel = root.querySelector('[data-edup-ship-label]');
  const fill = root.querySelector('[data-edup-fill]');
  const totalEl = root.querySelector('[data-edup-total]');
  const suggest = root.querySelector('[data-edup-suggest]');
  const suggestHead = root.querySelector('[data-edup-suggest-head]');
  const chips = [...root.querySelectorAll('[data-edup-add]')];
  const packEl = root.querySelector('[data-edup-pack]');
  const packText = root.querySelector('[data-edup-pack-text]');
  const packDefaultHtml = packText ? packText.innerHTML : '';

  let fmt = null;
  function money(cents, currency) {
    if (!fmt || fmt.currency !== currency) {
      fmt = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: currency || 'EUR' });
      fmt.currency = currency;
    }
    return fmt.format(cents / 100);
  }

  // Règle miroir de snippets/cart-tube-count.liquid : toute modification doit être faite aux deux endroits.
  function tubesPerUnit(handle) {
    const h = String(handle || '');
    if (h.includes('duo')) return 2;
    if (h.includes('pack') || h.includes('-x3')) return 3;
    return 1;
  }

  function render(cart) {
    const items = cart.items || [];
    const count = items.reduce((n, i) => n + i.quantity * tubesPerUnit(i.handle), 0);
    const hasPack = items.some((i) => tubesPerUnit(i.handle) > 1);
    const hasSub = items.some((i) => i.selling_plan_allocation);
    const free = hasSub || count >= freeQty;
    root.classList.toggle('is-free', free);
    if (shipLabel) {
      if (free) {
        shipLabel.innerHTML = T.free;
      } else {
        const missing = freeQty - count;
        const tpl = missing > 1 ? T.missingMany : T.missingOne;
        shipLabel.innerHTML = tpl.replace('[count]', String(missing)).replace('[price]', shipPrice);
      }
    }
    if (fill) fill.style.width = Math.min(100, (count / freeQty) * 100) + '%';
    if (totalEl) totalEl.textContent = money(cart.total_price || 0, cart.currency);

    if (packEl && packText) {
      packEl.hidden = hasPack;
      const packPrice = Number(packEl.dataset.packPrice) || 0;
      const tubePrice = Number(packEl.dataset.tubePrice) || 0;
      const diff = packPrice - (cart.total_price || 0);
      if (!hasPack && packPrice && diff > 0 && diff < tubePrice) {
        packText.innerHTML = T.packDiff.replace('[diff]', money(diff, cart.currency));
      } else {
        packText.innerHTML = packDefaultHtml;
      }
    }

    const inCart = new Set(items.map((i) => String(i.product_id)));
    let visible = 0;
    chips.forEach((chip) => {
      const owned = inCart.has(String(chip.dataset.productId));
      chip.classList.toggle('in-cart', owned || visible >= 3);
      if (!owned && visible < 3) visible++;
    });
    if (suggest) suggest.hidden = visible === 0;
    if (suggestHead) {
      suggestHead.textContent = free ? T.suggestFree : T.suggestAdd;
    }
  }

  function open() {
    root.hidden = false;
    requestAnimationFrame(() => root.classList.add('open'));
    document.documentElement.classList.add('edup-lock');
    if (panel) panel.focus({ preventScroll: true });
  }
  function close() {
    root.classList.remove('open');
    document.documentElement.classList.remove('edup-lock');
    setTimeout(() => { root.hidden = true; }, 300);
  }

  root.querySelectorAll('[data-edup-close]').forEach((b) => b.addEventListener('click', close));
  addEventListener('keydown', (e) => { if (e.key === 'Escape' && !root.hidden) close(); });

  document.addEventListener('cart:refresh', () => {
    fetch('/cart.js').then((r) => r.json()).then((cart) => {
      if (!cart.item_count) { if (!root.hidden) close(); return; }
      render(cart);
      if (root.hidden) open();
    }).catch(() => {});
  });

  chips.forEach((chip) => {
    chip.addEventListener('click', () => {
      chip.setAttribute('disabled', 'disabled');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(chip.dataset.variant), quantity: 1 }] }),
      }).then((r) => {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).then(() => {
        chip.removeAttribute('disabled');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }).catch(() => { chip.removeAttribute('disabled'); });
    });
  });
})();
